// Author thq
// Date 2021-04-08 16:49:30

class EmSppInvChangeTypeIct {
constructor({
        id = null,
        name = '',
        ictType = '',
        description = '',
        ictBusinessTableName = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.ictType = ictType;
    this.description = description;
    this.ictBusinessTableName = ictBusinessTableName;
}
}

function newEntity() {
return new EmSppInvChangeTypeIct();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ictType',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.grid.ictType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.grid.description',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'ictBusinessTableName',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.grid.ictBusinessTableName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nameFilter : "",
    ictTypeFilter : "",
    ictBusinessTableNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ictTypeFilter',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.filter.ictType',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ictBusinessTableNameFilter',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.filter.ictBusinessTableName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'ictType',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.entity.ictType',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'ictBusinessTableName',
        label: 'label.em.spareparts.emSppInvChangeTypeIct.entity.ictBusinessTableName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmSppInvChangeTypeIct, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
